import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Info({ idVariant = '', className }: Props) {
  return (
    <IconBase name="info" w={20} className={className}>
      <path d="M10 8.33299C10.46 8.33299 10.833 8.70699 10.833 9.16699V13.333C10.833 13.793 10.46 14.167 10 14.167C9.54 14.167 9.167 13.793 9.167 13.333V9.16699C9.167 8.70699 9.54 8.33299 10 8.33299ZM10 5.83299C10.46 5.83299 10.833 6.20699 10.833 6.66699C10.833 7.12699 10.46 7.49999 10 7.49999C9.54 7.49999 9.167 7.12699 9.167 6.66699C9.167 6.20699 9.54 5.83299 10 5.83299ZM10 16.667C6.324 16.667 3.333 13.676 3.333 9.99999C3.333 6.32399 6.324 3.33299 10 3.33299C13.676 3.33299 16.667 6.32399 16.667 9.99999C16.667 13.676 13.676 16.667 10 16.667ZM10 1.66699C5.397 1.66699 1.667 5.39699 1.667 9.99999C1.667 14.602 5.397 18.333 10 18.333C14.602 18.333 18.333 14.603 18.333 9.99999C18.333 5.39699 14.602 1.66699 10 1.66699Z" fill="currentColor"/>
    </IconBase>
  )
}

export default Info
